import React from 'react'
import { Header, Container, SimplePageHeader, DashboardHeader } from '../../components'
import { useInternationalization } from '../../features/i18n'
import { Sidebar } from './sidebar'

const MobileLayout = ({role, children, mobileNav, addButton, noContainer, title}) => {
  const [opened, setOpened] = React.useState(false)
  const { translate } = useInternationalization()
  const defaultTitle = translate('NAVIGATION', 'dashboard')
  const finalTitle = title ? title : defaultTitle

  const handleBack = () => {
    setOpened(true)
  }

  return (
    <div>
      <div style={{background:'#fff'}}>
        <Header role={role} noAudienceDropdown />
      </div>

      {/* <SimplePageHeader noPadding/> */}
      <div style={{ height: 77 }}></div>

      <DashboardHeader
        handleBack={handleBack}
        addButton={addButton}
      >
        {finalTitle}
      </DashboardHeader>

      { mobileNav && mobileNav }

      {
        !noContainer &&
        <Container>
          {children}
        </Container>
      }

      { noContainer && children }

      {/* Dashboard Menu */}
      {
        opened &&
        <div className="w-full h-screen fixed left-0 top-0 bg-white" style={{zIndex: 700}}>
          <SimplePageHeader noPadding/>
          <Sidebar onChange={() => setOpened(false)} role={role} />
        </div>
      }
    </div>
  )
}

export default MobileLayout
